import { handleActions } from 'redux-actions'
import {
  clearMacronutrientsFilters,
  createMacronutrientsInitialState,
  getProfilePreferences,
  getSelectedProfilePreference
} from './helpers'

import * as filtersActions from './actions'
import * as menuActions from '../menu/actions'

import { mapFullMenuProductTypesFilterData } from 'src/modules/MyPlan/components/Filters/utils'
import { FILTER_IDS } from 'src/modules/MyPlan/components/MenuBy/Filters/constants'
import { NEW_FILTERS } from './constants'

const initialState = {
  filterTypes: null,
  categories: [],
  diets: [],
  preferences: [],
  proteins: [],
  cuisines: [],
  avoids: [],
  chef: [],
  fullMenuProductTypes: [],
  fullMenuProductTypesSelected: [],
  fullMenuExcludedTypes: [],
  sortBy: null,
  selectedProfilePreference: null,
  sortingTypes: null,
  filteredMeals: [],
  selectedCategoryId: 0,
  quickFilterSelected: null,
  searchInput: '',
  menuSelected: null,
  menuItems: null,
  menuSortingSelected: 'all',
  hidePremiumFilter: false,
  macronutrientsRangeFilters: null,
  coreUxCategoryToScroll: null
}

export default handleActions(
  {
    [filtersActions.getFilterTypesSuccess]: state => ({
      ...state,
      filterTypes: NEW_FILTERS
    }),
    [filtersActions.setFilters]: (state, action) => {
      const { ...rest } = action.payload
      return {
        ...state,
        ...rest,
        ...getSelectedProfilePreference(state, rest)
      }
    },
    [filtersActions.setFullMenuProductTypeSelected]: (state, action) => {
      return {
        ...state,
        fullMenuProductTypesSelected: action.payload
      }
    },
    [filtersActions.setFullMenuExcludedTypes]: (state, action) => {
      return {
        ...state,
        fullMenuExcludedTypes: action.payload
      }
    },
    [filtersActions.setChefFilter]: (state, action) => ({
      ...state,
      chef: action.payload
    }),
    [filtersActions.setSortBy]: (state, action) => ({
      ...state,
      sortBy: action.payload
    }),
    [filtersActions.setProfilePreferenceFilter]: (state, action) => {
      const { profile, preferences } = action.payload
      const { restrictions, diets = [], tastes = [] } = profile || {}

      const proteins = state.filterTypes.proteins

      const mappedTastes = tastes.map(
        taste => proteins.find(protein => protein.name === taste.name) || {}
      )

      const availableDiets = diets.filter(
        d => !!state.filterTypes?.diets.find(diet => diet.id === d.id)
      )

      const profilePreferences = getProfilePreferences(
        preferences,
        restrictions
      )

      return {
        ...state,
        selectedProfilePreference: profile,
        diets: availableDiets,
        proteins: mappedTastes,
        preferences: profilePreferences
      }
    },
    [filtersActions.clearSortBy]: state => {
      const sortingTypes = state.sortingTypes

      return {
        ...state,
        sortBy: sortingTypes
          ? [{ ...sortingTypes[0], filterBy: sortingTypes[0].name }]
          : null
      }
    },
    [filtersActions.getSortingTypesSuccess]: (state, action) => {
      const sortingTypes = action.payload.sortingTypes

      return {
        ...state,
        sortingTypes,
        sortBy: [{ ...sortingTypes[0], filterBy: sortingTypes[0].name }]
      }
    },
    [filtersActions.setFilteredMeals]: (state, action) => {
      return {
        ...state,
        filteredMeals: action.payload.filteredMeals
      }
    },
    [filtersActions.setFullMenuQuickfilters]: (state, action) => {
      const fullMenuQF = action.payload.find(
        qf => qf.id === FILTER_IDS.FULL_MENU_ALL
      )
      return {
        ...state,
        menuItems: action.payload,
        ...(action.payload &&
          !state.menuSelected && { menuSelected: action.payload[0] }),
        fullMenuProductTypes: fullMenuQF?.categories?.map(
          mapFullMenuProductTypesFilterData
        ),
        ...(action.payload &&
          action.payload[0]?.quickFilterSelected && {
            quickFilterSelected: action.payload[0]?.quickFilterSelected
          })
      }
    },
    [filtersActions.setSortingMenuSelected]: (state, action) => {
      return {
        ...state,
        menuSortingSelected: action.payload
      }
    },
    [filtersActions.clearAllMacronutrientsFilter]: state => {
      if (!state.macronutrientsRangeFilters) return state
      return {
        ...state,
        macronutrientsRangeFilters: clearMacronutrientsFilters(
          state.macronutrientsRangeFilters
        )
      }
    },
    [filtersActions.setMacronutrientFilter]: (state, action) => {
      const { name, min, max, applied } = action.payload
      return {
        ...state,
        macronutrientsRangeFilters: {
          ...state.macronutrientsRangeFilters,
          [name]: {
            ...state.macronutrientsRangeFilters[name],
            currentMinRange: min,
            currentMaxRange: max,
            applied
          }
        }
      }
    },
    [filtersActions.setAllMacronutrientFilters]: (state, action) => {
      const filters = action.payload
      return {
        ...state,
        macronutrientsRangeFilters: filters
      }
    },
    [menuActions.getUserMenuSuccess]: (state, action) => {
      const nutrientsMaxValues = action.payload.menu.macronutrients
      return {
        ...state,
        macronutrientsRangeFilters: createMacronutrientsInitialState(
          nutrientsMaxValues
        )
      }
    }
  },
  initialState
)
